import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { checkboxData } from "./checkboxData";
import "./style.css";
import { useUserAuth } from "../../context/UserAuthContext";
import { useFormik } from "formik";
import { birthdayDecoratorTtkSchema } from "../schemas";
import axios from "axios";
import { NumericFormat } from "react-number-format";
import ThinksToKnowStatus from "./ThinksToKnowStatus";

const BirthdayTTK = () => {
  const [ttkEditMode, setTtkEditMode] = useState(false);
  const { user, language, token, currency } = useUserAuth();
  const merchant_id = user.uid;
  const [merchant, setMerchant] = useState({});
  const [thingsToKnow, setThinksToKnow] = useState([]);
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const getSingleDocumentHandler = async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/v1/thinkstoknow/${merchant_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = res.data.data;
      const details = data[0].details;
      // const details = rawDetails ? JSON.parse(rawDetails) : null;
      if (details) {
        setMerchant(details);
        // formik.setValues(details);
      }
    } catch (error) {
      console.log(`Error : ${error}`);
    }
  };
  useEffect(() => {
    if (!merchant_id) return;
    getSingleDocumentHandler();
  }, [merchant_id, token]);

  const workingSinceOption = checkboxData.workSinceOption;
  const serviceTypeOption = checkboxData.serviceTypeBirthdayDecor;
  const areaOfWorkingOption = checkboxData.areaOfWorking;
  // const experienceZoneOption = checkboxData.experienceZoneDecor

  const formik = useFormik({
    initialValues: {
      indoorBudget: Math.floor(merchant?.indoorBudget * currency.value) || "",
      outdoorBudget: Math.floor(merchant?.outdoorBudget * currency.value) || "",
      homeFunction: Math.floor(merchant?.homeFunction * currency.value) || "",
      workingSince: merchant?.workingSince || [],
      // experienceZone: merchant?.experienceZone || [],
      serviceType: merchant?.serviceType || [],
      areaOfWork: merchant?.areaOfWork || [],
    },
    enableReinitialize: true,
    validationSchema: birthdayDecoratorTtkSchema,
    onSubmit: async (values) => {
      try {
        const data = {
          id: merchant_id,
          details: {
            ...values,
            indoorBudget: Math.floor(
              values.indoorBudget * currency.country_value
            ),
            outdoorBudget: Math.floor(
              values.outdoorBudget * currency.country_value
            ),
            homeFunction: Math.floor(
              values.homeFunction * currency.country_value
            ),
          },
        };

        const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.status === 201) {
          toast.success("Things to know added successfully.");
          setMerchant(values);
          formik.setValues(values);
          setTtkEditMode(false);
        } else if (res.status === 202) {
          toast.success("Your update is pending approval by the admin.");
          setTtkEditMode(false);
        } else {
          toast.info(res.data.message || "Request submitted.");
          setTtkEditMode(false);
        }
      } catch (error) {
        console.error(`Error ${error}`);
        toast.error("An error occurred while submitting the data.");
      }
    },
  });
  return (
    <div className="page-wrapper">
      <div className="container-fluid">
         <ThinksToKnowStatus/>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="card-header  text-white text-center "
                style={{ backgroundColor: "#085f9a" }}
              >
                <h5>
                  {" "}
                  {language === "en"
                    ? "Things to Know"
                    : "जानने योग्य जानकारी भरे"}
                </h5>
              </div>
              <div className="card-body">
                {merchant && (
                  <>
                    <div className="table-responsive">
                      <table
                        className="table text-center"
                        cellPadding={0}
                        cellSpacing={0}
                        style={{ border: "1px solid #fff" }}
                      >
                        <tbody className="ttk_preview">
                          <tr style={{ color: "#41B0FA" }}>
                            <th style={{ width: "25%" }}>Working Since</th>
                            <th style={{ width: "25%" }}>
                              Starting Indoor Budget
                            </th>
                            <th style={{ width: "25%" }}>
                              Starting Outdoor Budget
                            </th>
                            <th style={{ width: "25%" }}>
                              Starting Decor Price (Home Function)
                            </th>
                          </tr>
                          <tr>
                            <td>
                              {merchant.workingSince?.map((item, index) => {
                                return <p key={index}>{item.value}</p>;
                              })}
                            </td>
                            <td>
                              {/* &#8377; {merchant.indoorBudget} */}
                              <NumericFormat
                                value={Math.floor(
                                  currency.value * merchant.indoorBudget
                                )}
                                displayType="text"
                                thousandsGroupStyle={
                                  currency.symbol === "₹" ? "lakh" : "thousand"
                                }
                                thousandSeparator=","
                                renderText={(formattedValue) => (
                                  <span>
                                    {currency.symbol}&nbsp;{formattedValue}
                                  </span>
                                )}
                              />
                            </td>
                            <td>
                              {/* &#8377; {merchant.outdoorBudget} */}
                              <NumericFormat
                                value={Math.floor(
                                  currency.value * merchant.outdoorBudget
                                )}
                                displayType="text"
                                thousandsGroupStyle={
                                  currency.symbol === "₹" ? "lakh" : "thousand"
                                }
                                thousandSeparator=","
                                renderText={(formattedValue) => (
                                  <span>
                                    {currency.symbol}&nbsp;{formattedValue}
                                  </span>
                                )}
                              />
                            </td>
                            <td>
                              {/* &#8377; {merchant.homeFunction} */}
                              <NumericFormat
                                value={Math.floor(
                                  currency.value * merchant.homeFunction
                                )}
                                displayType="text"
                                thousandsGroupStyle={
                                  currency.symbol === "₹" ? "lakh" : "thousand"
                                }
                                thousandSeparator=","
                                renderText={(formattedValue) => (
                                  <span>
                                    {currency.symbol}&nbsp;{formattedValue}
                                  </span>
                                )}
                              />
                            </td>
                          </tr>
                          <tr style={{ color: "#41B0FA" }}>
                            {/* <th>Experience Zone</th> */}
                            <th>Service Type</th>
                            <th>Area of Working </th>
                          </tr>
                          <tr>
                            <td>
                              {merchant.serviceType?.map((item, index) => {
                                return (
                                  <span key={index}>
                                    <i className="fa fa-check text-success" />
                                    <span>{item.value} </span>
                                  </span>
                                );
                              })}
                            </td>
                            <td>
                              {merchant.areaOfWork?.map((item, index) => {
                                return (
                                  <span key={index}>
                                    <i className="fa fa-check text-success" />
                                    <span>{item.value} </span>
                                  </span>
                                );
                              })}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
                <center>
                  <button
                    className="btn text-white mb-2"
                    style={{ backgroundColor: "#085f9a" }}
                    onClick={() => setTtkEditMode(!ttkEditMode)}
                  >{`${
                    merchant ? "Make Changes" : "Tell me more about yourself"
                  }`}</button>
                </center>
                {ttkEditMode && (
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Working Since <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={workingSinceOption}
                            selected
                            value={formik.values.workingSince}
                            onChange={(workingSince) =>
                              formik.setFieldValue("workingSince", workingSince)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.workingSince &&
                          formik.errors.workingSince ? (
                            <div className="text-danger">
                              {formik.errors.workingSince}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Service Type <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={serviceTypeOption}
                            selected
                            value={formik.values.serviceType}
                            onChange={(serviceType) =>
                              formik.setFieldValue("serviceType", serviceType)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.serviceType &&
                          formik.errors.serviceType ? (
                            <div className="text-danger">
                              {formik.errors.serviceType}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Starting Indoor Budget
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="Indoor Budget"
                            className="form-control"
                            name="indoorBudget"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.indoorBudget}
                          />
                          {formik.touched.indoorBudget &&
                          formik.errors.indoorBudget ? (
                            <div className="text-danger">
                              {formik.errors.indoorBudget}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Starting Outdoor Budget
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="Outdoor Budget"
                            className="form-control"
                            name="outdoorBudget"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.outdoorBudget}
                          />
                          {formik.touched.outdoorBudget &&
                          formik.errors.outdoorBudget ? (
                            <div className="text-danger">
                              {formik.errors.outdoorBudget}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Starting Decor Price (Home Function){" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="Home Function Decor Price"
                            className="form-control"
                            name="homeFunction"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.homeFunction}
                          />
                          {formik.touched.homeFunction &&
                          formik.errors.homeFunction ? (
                            <div className="text-danger">
                              {formik.errors.homeFunction}
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Area of Working{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={areaOfWorkingOption}
                            selected
                            value={formik.values.areaOfWork}
                            onChange={(areaOfWork) =>
                              formik.setFieldValue("areaOfWork", areaOfWork)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.areaOfWork &&
                          formik.errors.areaOfWork ? (
                            <div className="text-danger">
                              {formik.errors.areaOfWork}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <button
                        className="btn text-white"
                        type="submit"
                        style={{ backgroundColor: "#085f9a" }}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BirthdayTTK;
